import { graphql } from 'gatsby';

import { CustomerQuote, QuoteData } from '@mewa/ui';

import {
  ConfigType,
  ContentSectionItem,
  PossibleContentSections,
} from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage, StrapiImageData } from './image';

export type SingleQuoteData = {
  headline?: string;
  quote: string;
  image?: StrapiImageData;
  quoteGiver: string;
  quoteGiverInfo?: string;
  strapi_component: typeof componentName;
};

export type SingleQuotePreviewData = SingleQuoteData;

export const query = graphql`
  fragment SingleQuoteFragment on STRAPI__COMPONENT_SHARED_SINGLE_QUOTE {
    quote
    quoteGiver
    quoteGiverInfo
    headline
    image {
      ...StrapiImageFileFragment
    }
    strapi_component
  }
`;

const componentName = 'shared.single-quote';

const isComponent = (
  section: PossibleContentSections,
): section is ContentSectionItem<SingleQuoteData> =>
  section.strapi_component === componentName;

const Component = (props: SingleQuoteData) => {
  const quoteData: QuoteData = {
    headline: props.headline,
    quote: props.quote,
    customerName: props.quoteGiver,
    quoteGiverText: props.quoteGiverInfo ?? '',
    image: props.image ? <StrapiImage image={props.image} alt="" /> : undefined,
  };

  return (
    <CustomerQuote
      sx={{ marginBottom: [0, 0, 0, 0] }} // The blog uses <Spacer>, so we override the component's default margins
      data={quoteData}
    ></CustomerQuote>
  );
};

export const config: ConfigType<SingleQuoteData> = {
  Component,
  isComponent,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {
    image: '*',
  },
  mapProperties: (data) =>
    data.strapi_component === componentName ? data : null,
};
